module.exports = __webpack_public_path__ + "static/media/1.207b26de.jpg";